import { autobind } from 'frontools/decorators/Autobind';
import VanillaUtils from 'frontools/utils/VanillaUtils';

export class Tile {

    private _elTile          : HTMLElement;
    private _elAnimate       : HTMLElement;
    private _direction       : number = 0;
    private _animationDelay  : number = 0.6;

    constructor(private _elWrapper: HTMLElement) {
        this._elTile = this._elWrapper.querySelector('.m_tile_inner') as HTMLElement;
        this._elAnimate = this._elWrapper.querySelector('.m_tile_description') as HTMLElement;

        this._elTile.addEventListener('mouseleave', this._onMouseLeave);
        this._elTile.addEventListener('mouseenter', this._onMouseEnter);

        TweenMax.set(this._elAnimate, {opacity: 0});
    }

    @autobind
    private _onMouseEnter(e) {
        this._direction = this._determineDirection({x: e.pageX, y: e.pageY});
        this._showHover();
    }

    @autobind
    private _onMouseLeave(e) {
        this._direction = this._determineDirection({x: e.pageX, y: e.pageY});
        this._hideHover();
    }

    private _determineDirection(pos) {
        var w = this._elTile.clientWidth,
            h = this._elTile.clientHeight,
            top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop,
            left = (document.documentElement && document.documentElement.scrollLeft) || document.body.scrollLeft,
            // calculate the x and y to get an angle to the center of the div from that x and y.
            // gets the x value relative to the center of the DIV and "normalize" it
            x = (pos.x - (this._elTile.getBoundingClientRect().left+left) - (w / 2)) * (w > h ? (h / w) : 1),
            y = (pos.y - (this._elTile.getBoundingClientRect().top+top) - (h / 2)) * (h > w ? (w / h) : 1),
            // the angle and the direction from where the mouse came in/went out clockwise (TRBL=0123);
            // first calculate the angle of the point,
            // add 180 deg to get rid of the negative values
            // divide by 90 to get the quadrant
            // add 3 and do a modulo by 4 to shift the quadrants to a proper clockwise TRBL (top/right/bottom/left) **/
            direction = Math.round((((Math.atan2(y, x) * (180 / Math.PI)) + 180) / 90) + 3) % 4;
        
        return direction;
    }

    private _showHover() {
        TweenMax.set(this._elTile.querySelectorAll('p, h2'), {x:"0%", y:"0%", opacity:1});
        switch (this._direction) {
            case 0:
                TweenMax.fromTo(this._elAnimate, this._animationDelay, {x:"0%",y:"-100%", opacity: 0}, {x:"0%", y:"0%", opacity:1, ease:Expo.easeOut});
                break;
            case 1:
                TweenMax.fromTo(this._elAnimate, this._animationDelay, {x:"100%",y:"0%", opacity: 0}, {x:"0%", y:"0%", opacity:1, ease:Expo.easeOut});
                break;
            case 2:
                TweenMax.fromTo(this._elAnimate, this._animationDelay, {x:"0%",y:"100%", opacity: 0}, {x:"0%", y:"0%", opacity:1, ease:Expo.easeOut});
                break;
            case 3:
                TweenMax.fromTo(this._elAnimate, this._animationDelay, {x:"-100%",y:"0%", opacity: 0}, {x:"0%", y:"0%", opacity:1, ease:Expo.easeOut});
                break;
        }
    }

    private _hideHover() {
        switch (this._direction) {
            case 0:
                TweenMax.to(this._elAnimate, 1, {delay: 0.2, opacity: 0, ease:Expo.easeOut});
                TweenMax.to(this._elTile.querySelectorAll('p, h2'), 1, {delay: 0.2, x:"0%",y:-30, opacity: 0, ease:Expo.easeOut});
                break;
            case 1:
                TweenMax.to(this._elAnimate, 1, {delay: 0.2, opacity: 0, ease:Expo.easeOut});
                TweenMax.to(this._elTile.querySelectorAll('p, h2'), 1, {delay: 0.2, x:30,y:"0%", opacity: 0, ease:Expo.easeOut});
                break;
            case 2:
                TweenMax.to(this._elAnimate, 1, {delay: 0.2, opacity: 0, ease:Expo.easeOut});
                TweenMax.to(this._elTile.querySelectorAll('p, h2'), 1, {delay: 0.2, x:"0%",y:30, opacity: 0, ease:Expo.easeOut});
                break;
            case 3:
                TweenMax.to(this._elAnimate, 1, {delay: 0.2, opacity: 0, ease:Expo.easeOut});
                TweenMax.to(this._elTile.querySelectorAll('p, h2'), 1, {delay: 0.2, x:-30,y:"0%", opacity: 0, ease:Expo.easeOut});
                break;
        }
    }
    
    public destroy() {
        this._elTile.removeEventListener('mouseleave', this._onMouseLeave);
        this._elTile.removeEventListener('mouseenter', this._onMouseEnter);
        TweenMax.set(this._elAnimate, {clearProps: "all"});
        TweenMax.set(this._elTile.querySelectorAll('p, h2'), {clearProps: "all"});
    }
}
